import { render } from "./SectionMask.vue?vue&type=template&id=04218c58"
import script from "./SectionMask.vue?vue&type=script&lang=js"
export * from "./SectionMask.vue?vue&type=script&lang=js"

import "./SectionMask.vue?vue&type=style&index=0&id=04218c58&lang=scss"

import exportComponent from "/Users/lucas/Web/_loco/theadccawards/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__